export enum AdjustmentSign {
  CREDIT = <any>'CREDIT',
  DEBIT = <any>'DEBIT'
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/adjustment-sign.enum.ts